<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex flex-row justify-content-between">
        <h4 class="card-title mb-1">{{ $t('capabilities.title') }}</h4>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <div class="preview-list">
            <box-feature
              v-for="(item, i) in items1"
              :key="`col1-${i}`"
              :img-class="item.imgClass"
              :color-class="item.colorClass"
              :title="item.title"
              :subtitle="item.subtitle"
            ></box-feature>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="preview-list">
            <box-feature
              v-for="(item, i) in items2"
              :key="`col2-${i}`"
              :img-class="item.imgClass"
              :color-class="item.colorClass"
              :title="item.title"
              :subtitle="item.subtitle"
            ></box-feature>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoxFeatures',
  computed: {
    items1() {
      return [
        {
          imgClass: 'mdi mdi-chart-bar',
          colorClass: 'bg-primary',
          title: this.$t('capabilities.accountDowntime'),
          subtitle: this.$t('capabilities.trackEfficiency'),
        },
        {
          imgClass: 'mdi mdi-filter',
          colorClass: 'bg-primary',
          title: this.$t('capabilities.operatingModes'),
          subtitle: this.$t('capabilities.analyzesOperationModes'),
        },
        {
          imgClass: 'mdi mdi-flash',
          colorClass: 'bg-primary',
          title: this.$t('capabilities.registerPower'),
          subtitle: this.$t('capabilities.accountPower'),
        },
        {
          imgClass: 'mdi mdi-chart-line',
          colorClass: 'bg-primary',
          title: this.$t('capabilities.countRunningHours'),
          subtitle: this.$t('capabilities.runtimeTracking'),
        },
        {
          imgClass: 'mdi mdi-speedometer',
          colorClass: 'bg-primary',
          title: this.$t('capabilities.currentState'),
          subtitle: this.$t('capabilities.basicDataStatus'),
        },
      ];
    },
    items2() {
      return [
        {
          imgClass: 'mdi mdi-chart-areaspline',
          colorClass: 'bg-primary',
          title: this.$t('capabilities.periodicReports'),
          subtitle: this.$t('capabilities.performanceReport'),
        },
        {
          imgClass: 'mdi mdi-swap-vertical',
          colorClass: 'bg-primary',
          title: this.$t('capabilities.powerMonitoring'),
          subtitle: this.$t('capabilities.powerQuality'),
        },
        {
          imgClass: 'mdi mdi-message',
          colorClass: 'bg-primary',
          title: this.$t('capabilities.operNotifications'),
          subtitle: this.$t('capabilities.indicatorAcces'),
        },
        {
          imgClass: 'mdi mdi-account-multiple',
          colorClass: 'bg-primary',
          title: this.$t('capabilities.workAccounting'),
          subtitle: this.$t('capabilities.scheduleAccounting'),
        },
        {
          imgClass: 'mdi mdi-chart-pie',
          colorClass: 'bg-primary',
          title: this.$t('capabilities.downtimeCategory'),
          subtitle: this.$t('capabilities.classDowntime'),
        },
      ];
    },
  },
};
</script>

<style></style>
